import api from '@/api'

export default {
  all: (filter) => api('get', '/tax', filter),
  create: (data) => api('post', '/tax', data),
  show: (id) => api('get', `/tax/${id}`),
  delete: (id) => api('delete', `/tax/${id}`),
  update: (data) => api('put', `/tax/${data.id}`, data)
}
